// Context
import Activator from './DiscoveryActivator.vue'
import Content from './DiscoveryContent.vue'
import Description from './DiscoveryDescription.vue'
import Highlight from './DiscoveryHighlight.vue'
import Next from './DiscoveryNext.vue'
import Prev from './DiscoveryPrev.vue'
import Progress from './DiscoveryProgress.vue'
import Root from './DiscoveryRoot.vue'
import Skip from './DiscoverySkip.vue'
import Title from './DiscoveryTitle.vue'

export const Discovery = {
  Root,
  Activator,
  Content,
  Highlight,
  Title,
  Description,
  Progress,
  Prev,
  Next,
  Skip,
}
